import { AbstractControl, ValidationErrors } from '@angular/forms';
import { SpecialValidationType } from '@app/origami-api/constants/validation-type';
import { Field } from '@app/origami-api/constants/field-flag';
import { SpecialValidatorFnFactory } from '@app/shared/utils/special-validators/special-validators.model';

export const createDenyPastDatesValidator: SpecialValidatorFnFactory = function (
  validationOptions,
  fieldConfig,
  timeZoneService,
) {
  return function (control: AbstractControl): ValidationErrors | null {
    const currentDate = new Date(control.value);

    let minDate: Date;
    if (Field.Is.applyTimeZone(fieldConfig?.flags) && timeZoneService) {
      minDate = timeZoneService.setDateToRoomTimeZoneStartOfDay(new Date());
    } else {
      minDate = new Date();
    }

    currentDate.setHours(0, 0, 0, 0);
    minDate.setHours(0, 0, 0, 0);

    const isCurrentDateInPast = currentDate < minDate;

    return control.value && isCurrentDateInPast ? { [SpecialValidationType.DenyPastDates]: minDate } : null;
  };
};
